import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
    label_button: {
        background: "transparent",
        border: "none",
        composes: ["py-2", "pl-2"],
        cursor: "pointer",
        display: "flex",
        height: "100%",
        margin: 0,
        textAlign: "left",
        width: "100%",
        "&:hover": {
            color: "blue"
        }
    }
});

export default function ActiveLabel({
    children,
    handleClick
}) {
    const styles = useStyles();

    return (
        <>
            <button
                className={styles.label_button}
                onClick={handleClick}
            >
                { children }
            </button>
        </>
    );
}